import { FC, ReactNode } from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@mui/material';

type IBasicModal = {
	title?: string;
	titleKey?: string;
	titleValues?: { [key: string]: string };
	showBackIcon?: boolean;
	open: boolean;
	className?: string;
	titleClassName?: string;
	subClassName?: string;
	onClose: () => void;
	children: ReactNode;
	action?: ReactNode;
};

const BasicModal: FC<IBasicModal> = ({ onClose, open, subClassName, children, titleKey, titleValues, className, title, titleClassName, showBackIcon = true, action }) => {
	const { t } = useTranslation();

	const handleClose = () => {
		onClose();
	};

	return (
		<Dialog
			fullWidth
			open={open}
			onClose={handleClose}
			PaperProps={{
				className: `rounded-2xl px-3 pt-4 pb-8 max-w-[1152px] ${className}`,
			}}
		>
			<Box className={`flex items-center justify-between ${subClassName}`}>
				<DialogTitle className={`p-0 text-xl font-normal text-text-primary ${titleClassName}`}>
					{showBackIcon && <KeyboardArrowRightIcon />} {title ? title : t(titleKey!, titleValues!)}
				</DialogTitle>
				<IconButton>
					<CloseIcon className="text-text-secondary" onClick={handleClose} />
				</IconButton>
			</Box>
			<DialogContent className="p-0 px-6">{children}</DialogContent>
			{action && <DialogActions>{action}</DialogActions>}
		</Dialog>
	);
};

export default BasicModal;
